import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { WorkOrderAssignmentSubmission } from "../../shared/interfaces/WorkOrder";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useReassignWorkOrder(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["reassignWorkOrder"],
    async (assignmentSubmission: WorkOrderAssignmentSubmission) =>
      apiContext.assignmentApis.reassignWorkOrder(assignmentSubmission),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
